import { getCarouselItems } from 'services/apis/carousel';
import { GET_CAROUSEL_ITEMS } from 'constants/carousel';

export const getCarouselAction = () => ({
  type: GET_CAROUSEL_ITEMS,
  payload: getCarouselItems(),
});
